import React from "react";

import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { MainTabsValue } from "store/types";

import { usePortfolioConstructionContext } from "../Context/PortfolioConstructionContext";

interface MainTabsProps {
  value: MainTabsValue;
  onChange: (next: MainTabsValue) => void;
}

export const MainTabs: React.FC<MainTabsProps> = ({ value, onChange }) => {
  const { activeSliceKey, activeSliceName } = usePortfolioConstructionContext();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "100%", flexShrink: 0, gap: "16px" }}
    >
      <Stack direction="row" sx={{ gap: "16px", alignItems: "stretch" }}>
        <MainTab
          icon={<FactCheckOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Drift Monitoring"
          active={value === "drift-monitoring"}
          onClick={() => onChange("drift-monitoring")}
        />
      </Stack>
      {activeSliceKey && (
        <Stack direction="row" alignItems="center" gap="8px" sx={{ minWidth: 0, pb: "6px" }}>
          <Typography
            sx={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#071f35",
              flexShrink: 0
            }}
          >
            Slice:
          </Typography>
          <Box
            sx={{
              maxWidth: 280,
              padding: "4px 12px",
              borderRadius: "20px",
              backgroundColor: "#eaf3fb",
              color: "#1c6db5",

              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "16px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {activeSliceName || "—"}
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

interface MainTabProps {
  icon: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
}

const MainTab: React.FC<MainTabProps> = ({ icon, label, active, onClick }) => (
  <Stack
    direction="row"
    alignItems="center"
    onClick={onClick}
    sx={{
      gap: "8px",
      padding: "2px 0 6px 0",
      cursor: "pointer",
      borderBottom: active ? `2px solid ${"#071f35"}` : "2px solid transparent",
      color: active ? "#071f35" : "#496682"
    }}
  >
    {icon}
    <Typography
      sx={{
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "16px",
        color: "inherit",
        whiteSpace: "nowrap"
      }}
    >
      {label}
    </Typography>
  </Stack>
);
